<template>
  <div>
    <Skeleton class="w-full h-64" />
  </div>
</template>
